import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Audit > Coupon Applies — reads Admin_GetCouponApplyLog on db37, which returns the
// lk_admin_invoice_discount_log rows (last N days) as one JSON array string. Admin-gated
// in the proc (non-admins get []). Same wrapper/parse contract as the Cancel Reasons board.
export default class CouponApplyLogService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  // days = 7 | 30 | 90
  async getLog(days, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_COUPON_APPLY_LOG });
    let out = {};
    await api.endpoints[this.endpoint.GET_COUPON_APPLY_LOG]
      .getAllPost({ Days: days || 30 })
      .then((response) => {
        out = response.data;
      })
      .catch((err) => {
        out = this.common.handleError(err);
      });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getLog(days, true);
        return out;
      } catch (e) {
        return { statusCode: 401, message: "Session expired - please log in again." };
      }
    }

    // SingleResponse { result, statusCode, message, data } where data is a JSON array string.
    if (out && typeof out.data === "string") {
      try {
        return JSON.parse(out.data);
      } catch (e) {
        return [];
      }
    }
    return out && out.data !== undefined ? out.data : out;
  }
}
